export default "__VITE_ASSET___K9lrt0J__"